import JsFileDownloader from 'js-file-downloader';

export const getOrder = async (api, id) => {
  const order = await api.get(`/api/orders/${id}`);
  return order?.data.data.attributes;
};

export const getPaymentSchedule = async (api, id) => {
  const schedule = await api.get(`/api/orders/${id}/schedule`);
  return schedule?.data.payment_schedule;
};

export const getTransactions = async (api, id) => {
  const transactions = await api.get(`/api/orders/${id}/transactions`);
  return transactions?.data?.transactions;
};

export const getOrders = async (api, entity, type, pageIndex) => {
  if (entity) {
    const orders = await api.get(
      `/api/orders?filter[${type}]=${entity?.id}&page=${
        pageIndex + 1
      }&per_page=25&include=payment_schedule`,
    );
    return orders ? orders : [];
  }
};

export const getAgreement = (order, auth) => {
  const fileUrl = `${process.env.REACT_APP_API}/api/orders/${order.id}/agreement`;

  const agreementDownload = new JsFileDownloader({
    url: fileUrl,
    autoStart: false,
    contentType: 'application/json',
    headers: [
      { name: 'Accept', value: 'application/json' },
      { name: 'Authorization', value: `Bearer ${auth?.token.access_token}` },
    ],
  });

  return agreementDownload;
};
